import { useSortBy, useToggleRefinement } from 'react-instantsearch'

import React from 'react'
import { SORT_OPTIONS } from '@/constants/search'
import { Select } from '@audio-network/componentlibrary'
import styles from './SortBy.module.css'
import { useRefinements } from '../CurrentRefinements/CurrentRefinements.hooks'
import { useTranslation } from 'next-i18next'

const SortBy = (): JSX.Element => {
	const { t } = useTranslation(['search'])
	const { refinements } = useRefinements()
	const { value: instrumental } = useToggleRefinement({
		attribute: 'Instrumental',
	})

	const availableIndexes = {
		items: SORT_OPTIONS.items.map((option) => ({
			...option,
			label: t(option.label),
		})),
	}

	const { currentRefinement, options, refine } = useSortBy(availableIndexes)

	if (refinements.length === 0 && !instrumental.isRefined) {
		return
	}

	return (
		<Select
			className={styles.select}
			aria-label={t('sort-by')}
			data-testid="sort-by"
			value={currentRefinement}
			id="sortOptions"
			name="sortOptions"
			onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
				refine(event.target.value)
			}
			options={options}
		/>
	)
}

export default SortBy
